import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntersection } from 'react-use';
import { useLocation } from 'react-router-dom';
import BVReviews from 'components/consumer/PDP/BazaarVoice/BVReviews';
import useBvReviewsForceMount from 'components/consumer/PDP/BazaarVoice/useBvReviewsForceMount';
import usePdpFullVariantSku from '../state/pdpFullVariantSku/usePdpFullVariantSku';
const PDPCustomerPhotos = t0 => {
  const $ = _c(18);
  const {
    isLayoutRevamp: t1
  } = t0;
  const isLayoutRevamp = t1 === undefined ? false : t1;
  const variantSku = usePdpFullVariantSku();
  const containerRef = useRef(null);
  const forceMountReviews = useBvReviewsForceMount();
  const location = useLocation();
  const pdpIdentity = `${variantSku}:${location.pathname}`;
  let t2;
  if ($[0] !== pdpIdentity) {
    t2 = {
      identity: pdpIdentity,
      hasMounted: false
    };
    $[0] = pdpIdentity;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [mountLatch, setMountLatch] = useState(t2);
  const hasMounted = mountLatch.identity === pdpIdentity && mountLatch.hasMounted;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      rootMargin: "600px 0px"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const intersection = useIntersection(containerRef, t3);
  const hasApproachedViewport = intersection?.isIntersecting;
  const shouldMountReviews = hasApproachedViewport || forceMountReviews;
  let t4;
  let t5;
  if ($[3] !== hasMounted || $[4] !== pdpIdentity || $[5] !== shouldMountReviews) {
    t4 = () => {
      if (hasMounted) {
        return;
      }
      if (shouldMountReviews) {
        setMountLatch({
          identity: pdpIdentity,
          hasMounted: true
        });
      }
    };
    t5 = [shouldMountReviews, hasMounted, pdpIdentity];
    $[3] = hasMounted;
    $[4] = pdpIdentity;
    $[5] = shouldMountReviews;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  const t6 = !isLayoutRevamp;
  let t7;
  if ($[8] !== isLayoutRevamp || $[9] !== t6) {
    t7 = classNames("min-h-[400px]", {
      "[border-top:1px_solid_#e5e5e5] mt-14 pt-14": t6,
      "mt-0 pt-0": isLayoutRevamp
    });
    $[8] = isLayoutRevamp;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== hasMounted || $[12] !== shouldMountReviews || $[13] !== variantSku) {
    t8 = (hasMounted || shouldMountReviews) && <BVReviews key={variantSku} productId={variantSku} />;
    $[11] = hasMounted;
    $[12] = shouldMountReviews;
    $[13] = variantSku;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div ref={containerRef} className={t7} id="PDPCustomerPhotos">{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
PDPCustomerPhotos.propTypes = {
  isLayoutRevamp: PropTypes.bool
};
export default PDPCustomerPhotos;